'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Loading = require('./Loading.scss');

var _Loading2 = _interopRequireDefault(_Loading);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoadingIndicator = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(LoadingIndicator, _Component);

  function LoadingIndicator() {
    (0, _classCallCheck3.default)(this, LoadingIndicator);
    return (0, _possibleConstructorReturn3.default)(this, (LoadingIndicator.__proto__ || (0, _getPrototypeOf2.default)(LoadingIndicator)).apply(this, arguments));
  }

  (0, _createClass3.default)(LoadingIndicator, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          loading = _props.loading,
          theme = _props.theme;

      return _react2.default.createElement(
        'div',
        { className: _Loading2.default.loading + ' ' + (_Loading2.default[theme] ? _Loading2.default[theme] : _Loading2.default.default) + ' ' + className },
        loading ? _react2.default.createElement(
          'div',
          { className: _Loading2.default.loader + ' ' + _Loading2.default.dots },
          _react2.default.createElement('div', null)
        ) : ''
      );
    }
  }]);
  return LoadingIndicator;
}(_react.Component), _class.propTypes = {
  className: _react.PropTypes.string,
  loading: _react.PropTypes.bool,
  theme: _react.PropTypes.string
}, _temp);
exports.default = LoadingIndicator;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Loading/Loading.js
// module id = 1958
// module chunks = 0